var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',{staticClass:"accent text-h5 font-weight-bold pa-3"},[_c('v-icon',{attrs:{"color":"primary","left":""}},[_vm._v("mdi-calendar")]),_vm._v(" Calendários Mídias Sociais ")],1),_c('v-divider'),_c('v-card-text',[_c('ListaCalendarioMidiaSociais')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }